import React, { useRef, useState, useEffect } from 'react';
import { useSelector } from 'react-redux'
import DataTable from 'datatables.net-react'
import DT from 'datatables.net'

import MultiSelect from '../../../components/psc/lib/MultiSelect'
import Applicability from '../../../components/psc/lib/Applicability'

import useDocumentStatuses from '../../../hooks/useDocumentStatuses'
import useCustomerDocumentStatuses from '../../../hooks/useCustomerDocumentStatuses'
import useRecordStatuses from '../../../hooks/useRecordStatuses'
import useTableSlots from '../../../hooks/useTableSlots'

DataTable.use(DT)

const View = (props) => {
    const table = useRef([])
    const [tableData, setTableData] = useState(null)

    const reportView = props.reportView
    const reportModels = props.reportModels
    const reportDocumentStatuses = props.reportDocumentStatuses
    const reportIncludedDocumentStatuses = props.reportIncludedDocumentStatuses
    const reportCustomerDocumentStatuses = props.reportCustomerDocumentStatuses
    const reportRecordStatuses = props.reportRecordStatuses

    const { documentStatuses } = useDocumentStatuses()
    const includedDocumentStatuses = documentStatuses
    const { customerDocumentStatuses } = useCustomerDocumentStatuses()
    const { recordStatuses } = useRecordStatuses()
    const {
        filePathSlot,
    } = useTableSlots()

    const pscState = useSelector(state => state.pscState.value)
    const project = pscState.project

    useEffect(() => {
        const sections = reportView.sections
        table.current = table.current.slice(0, sections.length);

        let allTableData = []
        sections.forEach(section => {
            allTableData.push(section.contents || [])
        })
        setTableData(allTableData)
    }, [reportView])

    const options = {
        lengthMenu: [ 1000, 2000 ],
        pageLength: 1000,
        autoWidth: false,
        dom: 'fgtp',
        paging: false,
    }

    const columns = [
        { data: 'final_version_file_path', orderSequence: ['asc', 'desc'] },
        { data: 'reference', orderSequence: ['asc', 'desc'] },
        { data: 'title', orderSequence: ['asc', 'desc'] },
        { data: 'status', orderSequence: ['asc', 'desc'] }
    ]

    const tableHead = (
        <tr>
            <th style={{width: '10px'}}>&nbsp;</th>
            <th>Reference</th>
            <th>Title</th>
            <th>Status</th>
        </tr>
    )

    const tableSlots = {
        0: filePathSlot,
        1: (data, type, row) => {
            if( type !== 'display') {
                return data
            }
            const url = "/portfolio/"+project.id+"/"+row.cadm_object_href+"/"+row.content_id
            return (<span>{data} <a href={url} target="_blank" rel="noreferrer"><i className="fa fa-external-link "></i></a></span>)
        },
    }

    const renderSystems = () => {
        return (
            <Applicability
                label="Report filter"
                introText="Filter content with the following Product Tree items."
                projectId={project.id}
                projectType={project.project_type.name}
                options={project.project_systems}
                value={reportModels}
                disabled={true}
            />
        )
    }
    
    const renderStatusItem = (name, options, value) => {
        return (
            <div className="col-sm-4 m-b-xs" key={name}>
                {name} Status
                <MultiSelect
                    options={options}
                    value={value}
                    disabled={true}
                />
            </div>
        )
    }
    
    const renderStatus = () => {
        return (
            <div className="form-group">
                <label className="col-sm-2 control-label">Status</label>
                <div className="col-sm-8">
                    <div className="row form-text" key="status-container-1">
                        {renderStatusItem('Customer Document', customerDocumentStatuses, reportCustomerDocumentStatuses)}
                        {renderStatusItem('Document', documentStatuses, reportDocumentStatuses)}
                        {renderStatusItem('Included Document', includedDocumentStatuses, reportIncludedDocumentStatuses)}
                    </div>
                    <div className="row form-text" key="status-container-2">
                        {renderStatusItem('Record', recordStatuses, reportRecordStatuses)}
                    </div>
                </div>
            </div>
        )
    }

    const renderAllowedContent = () => {
        if( tableData === null ) {
            return null
        }

        return (
            <div className="form-group">
                <label className="col-sm-2 control-label"> </label>
                <div className="col-sm-8">
                    <div className="row">

                        <div className="col-sm-12 m-b-xs">
                            <div>
                                <div>
                                    {reportView.sections.map(function (section, index) {
                                        return (
                                            <div>
                                                <h3>{section.title}</h3>
                                                <DataTable
                                                    className="table table-striped table-bordered table-hover"
                                                    options={options}
                                                    columns={columns}
                                                    ref={el => table.current[index] = el}
                                                    data={tableData[index]}
                                                    slots={tableSlots}
                                                >
                                                    <thead>
                                                        {tableHead}
                                                    </thead>
                                                    <tfoot>
                                                        {tableHead}
                                                    </tfoot>
                                                </DataTable>
                                            </div>
                                        )
                                    })}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <div>
            <div className="form-group">
                <label className="col-sm-2"></label>
                <div className="col-sm-8">
                    <h3>Report Content</h3>
                    <p>
                    View your report content.
                    </p>
                </div>
            </div>
            
            {renderStatus()}
            
            <div className="hr-line-dashed"></div>
            
            {renderSystems()}
            
            {renderAllowedContent()}
                    
        </div>
    )
}

export default View
